// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./context/AuthContext.jsx";
import { Capacitor } from "@capacitor/core";
import { createHead, UnheadProvider } from "@unhead/react/client";
import "./firebase";
import { afInit } from "./analytics/appsflyer";

const Router = Capacitor.isNativePlatform() ? HashRouter : BrowserRouter;
const head = createHead();

afInit({
  debug: false,
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <UnheadProvider head={head}>
      <Router>
        <AuthProvider>
          <App />
        </AuthProvider>
      </Router>
    </UnheadProvider>
  </React.StrictMode>
);

// ---- Web-only: unregister any old service workers (keeps the SPA fresh on desktop web) ----
if (
  typeof window !== "undefined" &&
  typeof navigator !== "undefined" &&
  "serviceWorker" in navigator &&
  typeof navigator.serviceWorker.getRegistrations === "function" &&
  typeof __CAPACITOR_PLATFORM__ !== "undefined" &&
  __CAPACITOR_PLATFORM__ !== "ios" &&
  __CAPACITOR_PLATFORM__ !== "android"
) {
  window.addEventListener("load", async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const reg of regs) {
        await reg.unregister();
        console.log("✅ Unregistered old service worker:", reg);
      }
    } catch (err) {
      console.warn("⚠️ Failed to unregister service workers:", err);
    }
  });
}
